import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import LoginScreen from './screens/LoginScreen'
import RegisterScreen from './screens/RegisterScreen'
import ProfileScreen from './screens/ProfileScreen'
import ChatScreen from './screens/ChatScreen'
// import HomeScreen from './screens/HomeScreen'
import './App.css'
import ProtectedRoute from './routing/ProtectedRoute'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getCurrentUser } from './features/auth/authSlice'

function App() {

  const dispatch = useDispatch();

  // On app load, try to get current user (tokens are in localStorage.getItems())
  useEffect(() => {
    dispatch(getCurrentUser());
  }, [dispatch]);

  return (
    <Router>
      <Header />
      <main className='container content'>
        <Routes>
          <Route path='/' element={<LoginScreen />} />
          <Route path='/login' element={<LoginScreen />} />
          <Route path='/register' element={<RegisterScreen />} />
          <Route element={<ProtectedRoute />}>
            <Route path='/user-profile' element={<ProfileScreen />} />
            <Route path='/chat' element={<ChatScreen />} />
          </Route>
        </Routes>
      </main>
    </Router>
  )
}

export default App
